import {
  AllDataIcon,
  ContainersIcon,
  DatabasesIcon,
  HostsIcon,
  IdentityIcon,
  LoggingIcon,
  NetworkingIcon,
  QueuesIcon,
  ServerlessIcon,
  StorageIcon,
  AdministrationIcon,
  BatchProcessingIcon,
  EndpointManagementIcon,
  ThreatDetectionIcon,
  VulnerabilityManagementIcon,
} from '@cloudquery/base-icons';

import { CATEGORY_DISPLAY_MAP } from 'shared/base';

import { AssetResourceCategoryMenuItem } from '../types';

export const UNCATEGORIZED_CATEGORY_VALUE = 'uncategorized';
export const ANY_CATEGORY_VALUE = 'any';
export const ALL_DATA_CATEGORY_VALUE = null;

export const menuBase: AssetResourceCategoryMenuItem[] = [
  {
    count: 0,
    icon: AdministrationIcon,
    label: CATEGORY_DISPLAY_MAP.administration,
    subitems: [],
    value: 'administration',
  },
  {
    count: 0,
    icon: BatchProcessingIcon,
    label: CATEGORY_DISPLAY_MAP.batchProcessing,
    subitems: [],
    value: 'batchProcessing',
  },
  {
    count: 0,
    icon: HostsIcon,
    label: CATEGORY_DISPLAY_MAP.compute,
    subitems: [],
    value: 'compute',
  },
  {
    count: 0,
    icon: LoggingIcon,
    label: CATEGORY_DISPLAY_MAP.logging,
    subitems: [],
    value: 'logging',
  },
  {
    count: 0,
    icon: ContainersIcon,
    label: CATEGORY_DISPLAY_MAP.containers,
    subitems: [],
    value: 'containers',
  },
  {
    count: 0,
    icon: DatabasesIcon,
    label: CATEGORY_DISPLAY_MAP.databases,
    subitems: [],
    value: 'databases',
  },
  {
    count: 0,
    icon: QueuesIcon,
    label: CATEGORY_DISPLAY_MAP.queues,
    subitems: [],
    value: 'queues',
  },
  {
    count: 0,
    icon: StorageIcon,
    label: CATEGORY_DISPLAY_MAP.storage,
    subitems: [],
    value: 'storage',
  },
  {
    count: 0,
    icon: ThreatDetectionIcon,
    label: CATEGORY_DISPLAY_MAP.threatDetection,
    subitems: [],
    value: 'threatDetection',
  },
  {
    count: 0,
    icon: EndpointManagementIcon,
    label: CATEGORY_DISPLAY_MAP.endpointManagement,
    subitems: [],
    value: 'endpointManagement',
  },
  {
    count: 0,
    icon: VulnerabilityManagementIcon,
    label: CATEGORY_DISPLAY_MAP.vulnerabilityManagement,
    subitems: [],
    value: 'vulnerabilityManagement',
  },
  {
    count: 0,
    icon: NetworkingIcon,
    label: CATEGORY_DISPLAY_MAP.networking,
    subitems: [],
    value: 'networking',
  },
  {
    count: 0,
    icon: ServerlessIcon,
    label: CATEGORY_DISPLAY_MAP.serverless,
    subitems: [],
    value: 'serverless',
  },
  {
    count: 0,
    icon: IdentityIcon,
    label: CATEGORY_DISPLAY_MAP.identity,
    subitems: [],
    value: 'identity',
  },
  {
    count: 0,
    icon: AllDataIcon,
    label: CATEGORY_DISPLAY_MAP.allData,
    subitems: [],
    value: ALL_DATA_CATEGORY_VALUE,
  },
];

export enum TableStateUrlParam {
  DetailIds = 'detailIds',
  DisplayColumns = 'displayColumns',
  Filter = 'filter',
  FilterId = 'filterId',
  Pagination = 'pagination',
  Sort = 'sort',
}

export const DefaultPaginationModel = {
  page: 0,
  pageSize: 25,
};

export const DefaultTableState = {
  detailIds: [],
  filter: '',
  originalFilter: undefined,
  pagination: DefaultPaginationModel,
  sort: [],
};
